
import { Button } from "./ui/button";
import { ArrowRight, Shield, Lock, FileCheck } from "lucide-react";
import { useState } from "react";
import { SignUpDialog } from "./SignUpDialog";

export const Hero = () => {
  const [showSignUp, setShowSignUp] = useState(false);

  return (
    <div className="relative min-h-[80vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full bg-gradient-to-br from-purple-50 to-pink-50 -z-10" />
      <div className="container px-4 md:px-6">
        <div className="flex flex-col items-center space-y-4 text-center">
          <div className="space-y-2">
            <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl lg:text-6xl/none">
              Professional
              <span className="hero-gradient"> Training</span>
            </h1>
            <p className="mx-auto max-w-[700px] text-gray-500 md:text-xl dark:text-gray-400">
              Create and manage professional training resources for your organization. 
              Streamline your training workflow with our intelligent platform.
            </p>
          </div>
          <div className="space-x-4">
            <Button className="bg-primary hover:bg-primary/90" onClick={() => setShowSignUp(true)}>
              Get Started <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            <Button variant="outline">Book a Demo</Button>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-8">
            <div className="flex items-center space-x-2 text-sm text-gray-500">
              <Shield className="h-5 w-5 text-primary" />
              <span>Professional Training</span>
            </div>
            <div className="flex items-center space-x-2 text-sm text-gray-500">
              <Lock className="h-5 w-5 text-primary" />
              <span>Secure Platform</span>
            </div>
            <div className="flex items-center space-x-2 text-sm text-gray-500">
              <FileCheck className="h-5 w-5 text-primary" />
              <span>Quality Resources</span>
            </div>
          </div>
        </div>
      </div>
      <SignUpDialog open={showSignUp} onOpenChange={setShowSignUp} />
    </div>
  );
};
